import { motion, useInView } from "framer-motion";
import { useRef, useState } from "react";

const images = [
  { src: "/images/renders/render1.jpg", alt: "FINORA Havuz ve Mimari" },
  { src: "/images/renders/render7.jpg", alt: "FINORA Yaşam Alanı" },
  { src: "/images/renders/render8.jpg", alt: "FINORA Dış Cephe" },
  { src: "/images/renders/render9.jpg", alt: "FINORA Peyzaj" },
  { src: "/images/renders/render10.jpg", alt: "FINORA Gece Görünüm" },
  { src: "/images/renders/render12.jpg", alt: "FINORA Genel Bakış" },
  { src: "/images/renders/render14.jpg", alt: "FINORA Sahil Cephe" },
  { src: "/images/renders/render15.jpg", alt: "FINORA Sosyal Alanlar" },
  { src: "/images/renders/render11.jpg", alt: "FINORA Giriş Detay" },
];

export default function Gallery() {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-100px" });
  const [lightbox, setLightbox] = useState(null);

  return (
    <section
      id="gallery"
      data-testid="gallery-section"
      ref={ref}
      className="py-24 md:py-32 bg-[#F0EBE3]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 mb-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
          className="flex items-center justify-between"
        >
          <div>
            <div className="flex items-center gap-4 mb-4">
              <div className="w-8 h-[2px] bg-[#c13a05]" />
              <span className="font-sub text-[#c13a05] text-[11px] tracking-[0.25em] font-bold">
                GALERİ
              </span>
            </div>
            <h2 className="font-heading text-4xl sm:text-5xl font-normal text-[#1A1A1A] tracking-tight">
              Proje <span className="italic text-[#7d7441]">Görselleri</span>
            </h2>
          </div>
          <img src="/images/brandmarks/brandmark-siyah.svg" alt="" className="w-10 opacity-15 hidden md:block" />
        </motion.div>
      </div>

      {/* Gallery grid */}
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        <div className="grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-4">
          {images.map((img, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.5, delay: 0.1 + i * 0.06 }}
              className="img-reveal cursor-pointer relative group"
              onClick={() => setLightbox(i)}
              data-testid={`gallery-item-${i}`}
            >
              <img
                src={img.src}
                alt={img.alt}
                className="w-full h-[180px] md:h-[260px] object-cover"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors duration-300 flex items-center justify-center">
                <svg className="w-8 h-8 text-white opacity-0 group-hover:opacity-80 transition-opacity duration-300" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z" />
                </svg>
              </div>
            </motion.div>
          ))}
        </div>
      </div>

      {/* Lightbox */}
      {lightbox !== null && (
        <div
          className="fixed inset-0 z-[100] bg-black/90 flex items-center justify-center p-4"
          onClick={() => setLightbox(null)}
          data-testid="gallery-lightbox"
        >
          <button
            className="absolute top-6 right-6 text-white/70 hover:text-white transition-colors"
            onClick={() => setLightbox(null)}
            data-testid="lightbox-close"
          >
            <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
          <img
            src={images[lightbox].src}
            alt={images[lightbox].alt}
            className="max-w-full max-h-[85vh] object-contain"
            onClick={(e) => e.stopPropagation()}
          />
          {/* Nav arrows */}
          <button
            className="absolute left-4 top-1/2 -translate-y-1/2 text-white/50 hover:text-white transition-colors p-2"
            onClick={(e) => { e.stopPropagation(); setLightbox((lightbox - 1 + images.length) % images.length); }}
            data-testid="lightbox-prev"
          >
            <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
            </svg>
          </button>
          <button
            className="absolute right-4 top-1/2 -translate-y-1/2 text-white/50 hover:text-white transition-colors p-2"
            onClick={(e) => { e.stopPropagation(); setLightbox((lightbox + 1) % images.length); }}
            data-testid="lightbox-next"
          >
            <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
            </svg>
          </button>
        </div>
      )}
    </section>
  );
}
